module.exports = __webpack_public_path__ + "img/sdhb_logo.53c98025.png";